module["exports"] = [
  "Italia"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/default_country.js
// module id = 1396
// module chunks = 0